/**
 * Site header.
 *
 * @author Simon Lagerlöf <contact@smn.codes>
 * @copyright 2024 Simon Lagerlöf
 * @since 1.0.0
 */
import type AlpineComponent from '../types/alpine-component';

type SiteHeader = AlpineComponent<{
  menuActive: boolean;
  classNames: {
    disableScroll: string;
  };
  text: {
    open: string;
    close: string;
  };
}>;

type Props = Partial<SiteHeader['text']>;

export const siteHeader = (props: Props): SiteHeader => ({
  menuActive: false,

  classNames: {
    disableScroll: 'disable-scroll',
  },

  text: {
    open: props.open ?? '',
    close: props.close ?? '',
  },

  toggleMenu() {
    this.menuActive = !this.menuActive;

    if (this.menuActive) {
      document.body.classList.add(this.classNames.disableScroll);
    } else {
      document.body.classList.remove(this.classNames.disableScroll);
    }
  },

  hideMenu() {
    this.menuActive = false;

    document.body.classList.remove(this.classNames.disableScroll);
  },
});
